/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { Input, Modal } from 'antd';
import { AudioOutlined, StopOutlined } from '@ant-design/icons';
import './style.scss';
import Utils from '../../redux/utils';
import ResponseDialog from '../ResopnseDialog';
import HelpApi from '../../redux/middleware/help';

type Props = {
  handleDialog: any;
  open: boolean;
  component?: any;
};

const HelpModal = (props: Props) => {
  const company = Utils.getCurrentCompany();
  const brand = Utils.getCurrentBrand();
  let { handleDialog, open, component } = props;

  const [inputValue, setInputValue] = useState<string>('');
  const [errorList, setErrorList] = useState<any>({});
  const [errorStatus, setErrorStatus] = useState<boolean>(false);
  const [isListening, setIsListening] = useState<boolean>(false);
  const [transcription, setTranscription] = useState<any>();
  const [response, setResponse] = useState<any>();
  const [mediaRecorder, setMediaRecorder] = useState<MediaRecorder | null>(
    null
  );
  const [audioChunks, setAudioChunks] = useState<Blob[]>([]);

  // useEffect(() => {
  //   if (!('webkitSpeechRecognition' in window)) {
  //     let responseDialogData = {
  //       OnClick: () => {},
  //       type: 'error',
  //       messageArray: [`Speech recognition is not supported in this browser.`],
  //     };
  //     ResponseDialog(responseDialogData);
  //     return;
  //   }

  //   const recognition = new (window as any).webkitSpeechRecognition();
  //   recognition.continuous = false;
  //   recognition.lang = 'en-US';
  //   recognition.interimResults = false;
  //   recognition.onstart = () => setIsListening(true);
  //   recognition.onend = () => setIsListening(false);
  //   recognition.onerror = (e: any) => {
  //     console.error('Speech recognition error:', e);
  //     setIsListening(false);
  //   };
  //   recognition.onresult = (e: any) => {
  //     const text = e.results[0][0].transcript;
  //     setTranscription(text);
  //     setInputValue(text);
  //   };
  //   return () => {
  //     if (isListening) {
  //       recognition.stop();
  //     } else {
  //       recognition.start();
  //     }
  //   };
  // }, []);

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const recorder = new MediaRecorder(stream);
      let chunks: Blob[] = [];
      recorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          chunks.push(event.data);
        }
      };
      recorder.onstop = async () => {
        if (chunks.length > 0) {
          const audioBlob = new Blob(chunks, { type: 'audio/webm' });
          await handleAudioSubmit(audioBlob);
        }
        setAudioChunks([]);
        setMediaRecorder(null);
      };
      recorder.start();
      setMediaRecorder(recorder);
      setIsListening(true);
    } catch (error) {
      console.error('Error accessing microphone:', error);
    }
  };

  const stopRecording = () => {
    if (mediaRecorder) {
      mediaRecorder.stop();
      setIsListening(false);
    }
  };

  const handleAudioSubmit = async (audioBlob: Blob) => {
    try {
      if (!audioBlob) {
        setErrorStatus(true);
        setErrorList({ help: ['Audio recording failed. Please try again.'] });
        return;
      }
      console.log('audioBlob', audioBlob);
      const apiResponse = await HelpApi.getHelpAudioResponse(audioBlob);
      const formattedSteps = apiResponse?.guide_steps[0]
        .split('\n')
        .map((step: any) => step.trim())
        .filter((step: any) => step && !step.toLowerCase().includes('steps:'));
      setResponse(formattedSteps);
      setErrorStatus(false);
      setErrorList({});
    } catch (error) {
      console.error('Error submitting audio query:', error);
      setErrorStatus(true);
      setErrorList({
        help: ['Failed to process the audio. Please try again.'],
      });
    }
  };

  // const handleAudioSubmit = async (audioBlob: Blob) => {
  //   try {
  //     if (!audioBlob) {
  //       setErrorStatus(true);
  //       setErrorList({ help: ['Audio recording failed. Please try again.'] });
  //       return;
  //     }
  //     console.log('audioBlob', audioBlob);
  //     const formData = new FormData();
  //     formData.append('audio', audioBlob, 'recording.wav');
  //     console.log('formData', formData);
  //     const apiResponse = await HelpApi.getHelpAudioResponse(formData);
  //     console.log('apiResponse', apiResponse);
  //     if (!apiResponse || !apiResponse?.guide_steps) {
  //       throw new Error('Invalid response from server');
  //     }
  //     const formattedSteps = apiResponse?.guide_steps[0]
  //       .split('\n')
  //       .map((step: string) => step.trim())
  //       .filter(
  //         (step: string) => step && !step.toLowerCase().includes('steps:')
  //       );
  //     setResponse(formattedSteps);
  //     setErrorStatus(false);
  //     setErrorList({});
  //   } catch (error) {
  //     console.error('Error submitting audio query:', error);
  //     setErrorStatus(true);
  //     setErrorList({
  //       help: response.message,
  //     });
  //   }
  // };

  const handleSubmit = async () => {
    const query = inputValue || transcription;
    if (!query) {
      setErrorStatus(true);
      setErrorList({ help: ['Please enter a query or use speech.'] });
      return;
    }
    const apiResponse = inputValue
      ? await HelpApi.getHelpResponse(query)
      : await HelpApi.getHelpAudioResponse(
          new Blob(audioChunks, { type: 'audio/webm' })
        );
    if (apiResponse?.guide_steps) {
      const formattedSteps = apiResponse?.guide_steps
        .map((step: any) => step.trim())
        .filter((step: any) => step && !step.toLowerCase().includes('steps:'));
      setResponse(formattedSteps);
      setErrorStatus(false);
      setErrorList({});
    } else {
      setErrorStatus(true);
      setErrorList({
        help: apiResponse.message,
      });
    }
  };

  return (
    <div className="CategoryModal">
      <Modal
        title={<div className="title font">Help</div>}
        centered
        open={open}
        onCancel={() => handleDialog(false, {})}
        width={608}
        footer={null}
      >
        <div className="Modal">
          <div className="ingredientCategoryContainerWidth">
            <div className="wizardSubContainer help">
              <div className="CategoryModalwizardLabel">
                Enter your query <span className="sterik">*</span>
              </div>
              <div className="inputContainer">
                <Input
                  value={inputValue || transcription}
                  // placeholder="Type your query or use speech..."
                  placeholder="Input here..."
                  size="large"
                  onChange={(e) => setInputValue(e.target.value)}
                  required
                  className={
                    errorList['help']?.length > 0 ? 'dropdownUnitColorRed' : ''
                  }
                  // addonBefore={
                  //   <button
                  //     onClick={isListening ? stopRecording : startRecording}
                  //     style={{ background: 'none', border: 'none' }}
                  //   >
                  //     {isListening ? <StopOutlined /> : <AudioOutlined />}
                  //   </button>
                  // }
                />
              </div>
              {errorStatus && (
                <div className="subRecipeErrorMessages help-error">
                  {errorList['help']}
                </div>
              )}
            </div>
          </div>
          {response && (
            <>
              <h3 className="steps-heading">Steps:</h3>
              <div className="responseContainer">
                <ol>
                  {response.map((item: any, index: number) => (
                    <li key={index}>{item}</li>
                  ))}
                </ol>
              </div>
            </>
          )}
          <div className="butonGroup">
            <div
              className="wizard-button"
              onClick={() => handleDialog(false, {})}
            >
              Back
            </div>
            <div className="continue wizard-button" onClick={handleSubmit}>
              Submit
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default HelpModal;
